<div class="flex justify-center items-start py-1 h-full">
  <div class="bg-white rounded-2xl max-w-2xl w-full flex flex-col h-full">
    
    <!-- Sticky Top Bar with better spacing -->
    <div class="sticky top-0 bg-white z-10 px-1 rounded-t-2xl py-3">
      <button class="flex items-center text-teal-700 font-medium hover:underline" (click)="goBack()">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
        {{ 'general.backRegister' | transloco }}
      </button>
    </div>

    <!-- Improved scrollable container with flex-grow -->
    <div class="custom-scrollbar overflow-y-auto px-6 pt-4 pb-6 flex-grow" 
         style="max-height: calc(100vh - 120px); min-height: 300px;">
      <div class="space-y-4 pr-4">
        <div [innerHTML]="termsContent"></div>
        <!-- Extra space at bottom -->
        <div class="pb-6"></div> <!-- Increased padding for more space -->
      </div>
    </div>
  </div>
</div>